__turbopack_context__.v({
  "grid": "dSgAiG_grid",
  "loader": "dSgAiG_loader",
  "loading": "dSgAiG_loading",
  "nullState": "dSgAiG_nullState",
  "profileSection": "dSgAiG_profileSection",
  "scrollGrid": "dSgAiG_scrollGrid",
  "title": "dSgAiG_title",
});
